<template>
  <v-row class="ma-4">
    <v-col cols="12" sm="6" class="px-1">
      <v-date-picker
        class="border"
        ref="picker"
        v-model="date"
        locale="vi"
        :picker-date.sync="pickerDate"
        :events="arrayEvents"
        color="#0D47A1"
        full-width
        event-color="red"
      ></v-date-picker>
    </v-col>
    <v-col v-if="date !== null" cols="12" sm="6" class="pl-4">
      <div class="text-h6">{{ formatDateTimeTable(date) }}</div>
      <div class="ml-2">
        <div v-if="!currentDateEvent.length">Không có lịch vào ngày này</div>
        <div v-else v-for="lesson in currentDateEvent" :key="lesson.id" class="subheading mt-2">
          <div>{{ lesson.startTime }} - {{ lesson.gradeTitle }} - {{ lesson.classTitle }}</div>
          <div v-if="lesson.classroom">
            (Phòng {{ lesson.classroom.name }}, Toà {{ lesson.classroom.building }}, Tầng {{ lesson.classroom.floor }})
          </div>
          <v-divider class="my-2"></v-divider>
        </div>
      </div>
    </v-col>
    <v-col v-else cols="12" sm="6" class="d-flex justify-center align-center">
      <div class="text-h6">Vui lòng chọn ngày để xem chi tiết</div>
    </v-col>
  </v-row>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
export default {
  data: () => ({
    date: null,
    arrayEvents: [],
    dateEvents: {},
    currentDateEvent: [],
    pickerDate: null,
    notes: [],
    loading: false,
    moment,
  }),
  props: {
    teacher: String,
    type: String,
  },
  computed: {
    ...mapState('lesson', ['lessons']),
  },
  methods: {
    ...mapActions('lesson', ['fetchLessons']),
    groupByDate(arr) {
      const groups = {}
      arr.forEach((item) => {
        const date = moment(item.date)
        const dateKey = date.format('YYYY-MM-DD')
        if (!groups[dateKey]) {
          groups[dateKey] = []
        }
        groups[dateKey].push(item)
      })

      return groups
    },
    getFirstAndLastDayOfMonth(yearMonth) {
      const date = moment(yearMonth, 'YYYY-MM')

      const start = date.startOf('month').toISOString()
      const end = date.endOf('month').toISOString()

      return { start, end }
    },
    formatDateTimeTable(date) {
      moment.locale('vi')
      const inputDate = date
      const formattedDate = moment(inputDate).format('dddd, DD/MM/YYYY')
      return formattedDate.replace(/^./, (str) => str.toUpperCase())
    },
  },
  watch: {
    lessons: {
      handler(value) {
        if (!value.length) {
          this.dateEvents = {}
          this.arrayEvents = []
          return
        }

        this.dateEvents = this.groupByDate(value)
        this.arrayEvents = Object.keys(this.dateEvents)
      },
      deep: true,
    },
    date: {
      handler(value) {
        const events = this.dateEvents[value]
        if (!events) this.currentDateEvent = []
        if (events) this.currentDateEvent = events
      },
      deep: true,
    },
    pickerDate: {
      async handler(value) {
        const { start, end } = this.getFirstAndLastDayOfMonth(value)
        const params = { date_gte: start, date_lte: end }
        if (this.type === 'teacher') params.teachers = this.teacher
        await this.fetchLessons(params)
      },
      deep: true,
    },
  },
}
</script>
<style scoped>
.border {
  border: 1px solid #e0e0e0;
}
</style>
